import React from 'react';
import { PropTypes } from 'prop-types';

import moment from 'moment-timezone';

import dateFormatters from 'utils/dateAndTimes/formatters';

const getDateHeaderByType = ({ value, type, t }) => {
  const day = moment(value);
  const now = moment().format('YYYY-MM-DD');

  if (type === 'active' && day.isSameOrBefore(now)) {
    return null;
  }
  return (
    <p className="sectionHeader">
      {dateFormatters.getHumanReadableFormattedDate({
        value,
        t,
        format: 'friendly',
      })}
    </p>
  );
};

getDateHeaderByType.propTypes = {
  value: PropTypes.string,
  type: PropTypes.string,
  t: PropTypes.func,
};

getDateHeaderByType.defaultProps = {
  value: '',
  type: '',
  t: (t) => t,
};

const getRecurringHeaderByStatus = ({ status, t }) => {
  const headerByStatus = {
    active: '',
    finished: t('finished_recurring_orders_header'),
  };

  return <p className="sectionHeader">{headerByStatus[status]}</p>;
};

getRecurringHeaderByStatus.propTypes = {
  status: PropTypes.string,
  t: PropTypes.func,
};

getRecurringHeaderByStatus.defaultProps = {
  status: '',
  t: (t) => t,
};

export { getDateHeaderByType, getRecurringHeaderByStatus };
